// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Display Fix for ngx-bootstrap modals */

/* Ensure modal is visible and properly positioned - only when it has the show class */
.modal.show {
  display: block !important;
  opacity: 1 !important;
  z-index: 1050 !important;
  position: fixed !important;
}

/* Center the modal dialog */
.modal-dialog {
  position: relative;
  margin: 10px auto !important;
  max-width: 90vw;
  top: 10px !important;
}

/* Ensure modal content is visible */
.modal-content {
  background-color: white !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 0.375rem !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  padding: 2px !important;
  margin: 2px !important;
}

/* Fix modal backdrop */
.modal-backdrop {
  z-index: 1040 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Remove duplicate modal.show rule - handled above */

/* Large modal adjustments */
.modal-lg-custom .modal-dialog {
  max-width: 80vw !important;
  width: 80vw !important;
}

/* Prevent modal from going off-screen */
.modal-dialog {
  max-height: fit-content !important;
  height: auto !important;
  overflow-y: visible !important;
}

/* Modal body scrolling */
.modal-body {
  max-height: fit-content !important;
  overflow-y: visible !important;
  padding: 10px !important;
  margin: 5px !important;
}

/* Remove any negative margins that might cause positioning issues */
.modal-dialog {
  margin-top: 150px !important;
  margin-bottom: 10px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
